<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Создать новое занятие</h4>
            </div>
            <div class="card-body">

              <div v-if="successMessage" class="alert alert-success">
                <span>{{ successMessage }}</span>
              </div>
              <div v-if="errorMessage" class="alert alert-danger">
                <span>{{ errorMessage }}</span>
              </div>

              <form @submit.prevent="createSchedule">

                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Тип занятия</label>
                      <select class="form-control" v-model="form.sessionType">
                        <option :value="null">Без типа</option>
                        <option :value="2">Лекция</option>
                        <option :value="3">Практика</option>
                        <option :value="4">Лабораторная</option>
                        <option :value="5">Пересдача</option>
                        <option :value="6">Экзамен</option>
                        <option :value="7">Комиссия</option>
                        <option :value="8">Зачёт</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Формат проведения</label>
                      <select class="form-control" v-model="form.isOnline">
                        <option :value="false">Оффлайн</option>
                        <option :value="true">Онлайн</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-3">
                    <div class="form-group custom-dropdown-container">
                      <label>Группа</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="searchStrings.group"
                        @focus="activeDropdown = 'group'"
                        placeholder="Поиск группы..."
                        required
                      >
                      <ul v-if="activeDropdown === 'group'" class="custom-dropdown-list">
                        <li v-for="g in filteredGroups" :key="g.id" @mousedown="selectItem('group', g)">
                          {{ g.name }} ({{ g.groupCourse }} курс)
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="form-group custom-dropdown-container">
                      <label>Предмет</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="searchStrings.subject"
                        @focus="activeDropdown = 'subject'"
                        placeholder="Поиск предмета..."
                        required
                      >
                      <ul v-if="activeDropdown === 'subject'" class="custom-dropdown-list">
                        <li v-for="s in filteredSubjects" :key="s.id" @mousedown="selectItem('subject', s)">
                          {{ s.name }}
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="form-group custom-dropdown-container">
                      <label>Преподаватели</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="searchStrings.tutor"
                        @focus="activeDropdown = 'tutor'"
                        placeholder="Поиск и добавление..."
                      >
                      <ul v-if="activeDropdown === 'tutor'" class="custom-dropdown-list">
                        <li v-for="t in filteredTutors" :key="t.id" @mousedown="selectItem('tutor', t)">
                          {{ t.name }}
                        </li>
                      </ul>

                      <div class="selected-items mt-2">
                        <span
                          v-for="(tutor, index) in selectedTutors"
                          :key="index"
                          class="badge badge-info mr-1 mb-1"
                          style="font-size: 12px; cursor: pointer;"
                          @click="removeTutor(index)"
                        >
                          {{ tutor.name }} <span aria-hidden="true">&times;</span>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="form-group custom-dropdown-container">
                      <label>Семестр</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="searchStrings.semester"
                        @focus="activeDropdown = 'semester'"
                        placeholder="Поиск семестра..."
                        required
                      >
                      <ul v-if="activeDropdown === 'semester'" class="custom-dropdown-list">
                        <li v-for="sem in filteredSemesters" :key="sem.id" @mousedown="selectItem('semester', sem)">
                          {{ sem.name }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <div v-if="form.isOnline" class="form-group">
                      <label>Ссылка</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="form.link"
                        placeholder="Занятие онлайн"
                      >
                    </div>

                    <div class="form-group">
                      <label>Аудитория</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="form.roomId"
                        :placeholder="'Аудитория'"
                      >
                    </div>


                  </div>
                </div>

                <div class="row">
                  <div class="col-md-3">
                    <div class="form-group">
                      <label>День недели</label>
                      <select class="form-control" v-model="form.dayOfWeek" required>
                        <option :value="1">Понедельник</option>
                        <option :value="2">Вторник</option>
                        <option :value="3">Среда</option>
                        <option :value="4">Четверг</option>
                        <option :value="5">Пятница</option>
                        <option :value="6">Суббота</option>
                        <option :value="7">Воскресенье</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label>Тип недели</label>
                      <select class="form-control" v-model="form.weekType" required>
                        <option :value="1">Каждая</option>
                        <option :value="2">Верхняя</option>
                        <option :value="3">Нижняя</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="form-group">
                      <label>Время начала</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="form.startTime"
                        @input="handleTimeInput('startTime', $event)"
                        placeholder="HH:mm"
                        pattern="^([01]\d|2[0-3]):([0-5]\d)$"
                        maxlength="5"
                        required
                      >
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label>Время конца</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="form.endTime"
                        @input="handleTimeInput('endTime', $event)"
                        placeholder="HH:mm"
                        pattern="^([01]\d|2[0-3]):([0-5]\d)$"
                        maxlength="5"
                        required
                      >
                    </div>
                  </div>
                </div>

                <div class="row mt-4">
                  <div class="col-md-12 d-flex justify-content-start">
                    <button type="submit" class="btn btn-info btn-fill" :disabled="loading">
                      {{ loading ? 'Сохранение...' : 'Создать расписание' }}
                    </button>
                    <router-link to="/admin/manage-schedule" class="btn btn-secondary btn-fill ml-2">
                      Отмена
                    </router-link>
                  </div>
                </div>

              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { API_URL } from '../server';

export default {
  name: 'CreateSchedule',
  data() {
    return {
      groups: [], subjects: [], tutors: [], semesters: [],
      loading: false,
      successMessage: null,
      errorMessage: null,
      activeDropdown: null,

      selectedTutors: [],

      searchStrings: {
        group: '',
        subject: '',
        tutor: '',
        semester: ''
      },

      form: {
        name: '',
        sessionType: 2,
        groupId: '',
        subjectId: '',
        semesterId: '',
        roomId: '',
        link: '',
        isOnline: false,
        dayOfWeek: 1,
        weekType: 1,
        startTime: '',
        endTime: ''
      }
    };
  },
  // ADDED: Watcher to clear roomId if switched to Online
  watch: {
    'form.isOnline'(newVal) {
      if (newVal === true) {
        this.form.roomId = '';
      }
    }
  },
  computed: {
    filteredGroups() {
      return this.groups.filter(i => i.name.toLowerCase().includes(this.searchStrings.group.toLowerCase()));
    },
    filteredSubjects() {
      return this.subjects.filter(i => i.name.toLowerCase().includes(this.searchStrings.subject.toLowerCase()));
    },
    filteredTutors() {
      const selectedIds = this.selectedTutors.map(t => t.id);
      return this.tutors.filter(i =>
        i.name.toLowerCase().includes(this.searchStrings.tutor.toLowerCase()) &&
        !selectedIds.includes(i.id)
      );
    },
    filteredSemesters() {
      return this.semesters.filter(i => i.name.toLowerCase().includes(this.searchStrings.semester.toLowerCase()));
    }
  },
  mounted() {
    this.loadDropdowns();
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    async loadDropdowns() {
      const token = localStorage.getItem('token');
      const headers = { 'Authorization': `Bearer ${token}` };
      try {
        const [groupRes, subjRes, tutorRes, semRes] = await Promise.all([
          axios.get(API_URL + '/api/group', { headers }),
          axios.get(API_URL + '/api/subject', { headers }),
          axios.get(API_URL + '/api/tutor', { headers }),
          axios.get(API_URL + '/api/semester', { headers })
        ]);
        if (groupRes.data.code === 200) this.groups = groupRes.data.data;
        if (subjRes.data.code === 200) this.subjects = subjRes.data.data;
        if (tutorRes.data.code === 200) this.tutors = tutorRes.data.data;
        if (semRes.data.code === 200) this.semesters = semRes.data.data;
      } catch (error) {
        console.error("Error loading dropdowns:", error);
      }
    },
    handleTimeInput(field, event) {
      let input = event.target.value.replace(/[^0-9]/g, '');
      if (input.length > 4) input = input.slice(0, 4);
      if (input.length > 2) {
        this.form[field] = input.slice(0, 2) + ':' + input.slice(2);
      } else {
        this.form[field] = input;
      }
    },
    selectItem(type, item) {
      if (type === 'tutor') {
        if (!this.selectedTutors.find(t => t.id === item.id)) {
          this.selectedTutors.push(item);
        }
        this.searchStrings.tutor = '';
      } else {
        this.searchStrings[type] = item.name;
        this.form[type + 'Id'] = item.id;
      }
      this.activeDropdown = null;
    },
    removeTutor(index) {
      this.selectedTutors.splice(index, 1);
    },
    handleClickOutside(e) {
      if (!e.target.closest('.custom-dropdown-container')) {
        this.activeDropdown = null;
      }
    },
    async createSchedule() {
      if (!this.form.groupId || !this.form.subjectId || this.selectedTutors.length === 0 || !this.form.semesterId) {
        this.errorMessage = "Пожалуйста, выберите корректные значения (группа, предмет, преподаватели, семестр).";
        return;
      }

      this.loading = true;
      this.errorMessage = null;

      const token = localStorage.getItem('token');
      const formatTimePayload = (t) => (t && t.length === 5 ? t + ':00' : t || '00:00:00');

      try {
        const payload = {
          ...this.form,
          sessionType: this.form.sessionType ? parseInt(this.form.sessionType) : null,
          tutorIds: this.selectedTutors.map(t => parseInt(t.id)),
          groupId: parseInt(this.form.groupId),
          subjectId: parseInt(this.form.subjectId),
          semesterId: parseInt(this.form.semesterId),
          startTime: formatTimePayload(this.form.startTime),
          endTime: formatTimePayload(this.form.endTime)
        };

        delete payload.tutorId;

        const response = await axios.post(API_URL + '/api/schedule', payload, {
          headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
        });

        if (response.data.code === 200) {
          this.successMessage = "Занятие успешно создано!";
          setTimeout(() => this.$router.push('/admin/manage-schedule'), 1000);
        } else {
          this.errorMessage = "Не удалось создать занятие.";
        }
      } catch (error) {
        this.errorMessage = "Ошибка сервера.";
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.custom-dropdown-container { position: relative; }
.custom-dropdown-list {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 1000;
  margin: 2px 0 0 0;
  padding: 5px 0;
  list-style: none;
  background-color: #1a1a1a;
  border: 1px solid #333;
  border-radius: 4px;
  max-height: 200px;
  overflow-y: auto;
  box-shadow: 0 4px 12px rgba(0,0,0,0.5);
}
.custom-dropdown-list li {
  padding: 10px 15px;
  color: #fff;
  cursor: pointer;
  font-size: 14px;
}
.custom-dropdown-list li:hover { background-color: #333; }
.ml-2 { margin-left: 10px; }
.mr-1 { margin-right: 5px; }
.mb-1 { margin-bottom: 5px; }
.d-flex { display: flex; }
.badge-info {
  background-color: #1dc7ea;
  color: #fff;
  padding: 5px 10px;
  border-radius: 12px;
  display: inline-block;
}
</style>
